import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentPopupOffset = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.offset,
)
